<template>
  <div class="market-card" @click="emit('select', item)">
    <div class="market-card__cover" :style="{ background: coverBg }">
      <el-image v-if="item.coverUrl" :src="item.coverUrl" fit="cover" class="market-card__img" />
      <div v-else class="market-card__placeholder">
        <span>{{ item.name?.slice(0, 1) || '模' }}</span>
      </div>
    </div>
    <div class="market-card__body">
      <div class="market-card__title">{{ item.name }}</div>
      <div class="market-card__desc">{{ item.brief || '点击查看详情' }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MarketTemplateVO } from '@/api/market/home'

defineOptions({ name: 'MarketTplCard' })

const props = defineProps<{ item: MarketTemplateVO }>()
const emit = defineEmits<{ (e: 'select', item: MarketTemplateVO): void }>()

const PALETTE = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#ec4899']

const coverBg = computed(() => {
  const id = Number(props.item?.id || 0)
  return PALETTE[id % PALETTE.length]
})
</script>

<style lang="scss" scoped>
.market-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 1px 4px rgb(0 0 0 / 6%);
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgb(0 0 0 / 10%);
  }

  &__cover {
    position: relative;
    height: 140px;
    overflow: hidden;
  }

  &__img {
    width: 100%;
    height: 100%;
  }

  &__placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #fff;
    font-size: 32px;
    font-weight: 600;
  }

  &__body {
    padding: 10px 12px 12px;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
  }

  &__desc {
    margin-top: 4px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
